import _ from 'lodash';
import { formConstants } from '../../../../utils/constants/form-constants';
import { isEmpty } from '../../../../utils/obj-utils';
import { createDateFromExisting } from '../../../../utils/date-utils';
import { domainConstants } from '../../../../utils/constants/domain-constants';
import { hasValue } from '../../../../../../../general/js/general-helpers';

const UserDetailsFormData = (
    {
        ssoDomain,
        ssoUserDetailsFields,
        updateUserDetailsCallbackUrl,
        removeAccountCallbackUrl
    },
    userAccountData
) => {
    function buildUserDetailsFormData() {
        const formData = getUserDetailsFields();
        return getUserDetailsFieldsWithDefaultValues(formData);
    }

    function getUserDetailsFields() {
        const formData = {};
        const { formTitle, actionSuccessText, emailChangedConflictMessage } = ssoUserDetailsFields;
        formData[formConstants.formTitle] = formTitle;
        formData[formConstants.callBackUrl] = updateUserDetailsCallbackUrl;
        formData[formConstants.ssoDomain] = ssoDomain;
        formData[formConstants.removeAccountCallbackUrl] = removeAccountCallbackUrl;
        formData[formConstants.actionSuccessText] = actionSuccessText;
        formData[formConstants.emailChangedConflictMessage] = emailChangedConflictMessage;
        formData[formConstants.emailAddress] = ssoUserDetailsFields[formConstants.emailAddress];
        formData[formConstants.confirmEmailAddress] = ssoUserDetailsFields[formConstants.confirmEmailAddress];
        formData[formConstants.title] = ssoUserDetailsFields[formConstants.title];
        formData[formConstants.firstName] = ssoUserDetailsFields[formConstants.firstName];
        formData[formConstants.lastName] = ssoUserDetailsFields[formConstants.lastName];
        formData[formConstants.dateOfBirth] = ssoUserDetailsFields[formConstants.dateOfBirth];
        formData[formConstants.mainAddressLabel] = ssoUserDetailsFields[formConstants.mainAddressLabel];
        formData[formConstants.country] = ssoUserDetailsFields[formConstants.country];
        formData[formConstants.county] = ssoUserDetailsFields[formConstants.county];
        formData[formConstants.state] = ssoUserDetailsFields[formConstants.state];
        formData[formConstants.addressLine1] = ssoUserDetailsFields[formConstants.addressLine1];
        formData[formConstants.addressLine2] = ssoUserDetailsFields[formConstants.addressLine2];
        formData[formConstants.addressLine3] = ssoUserDetailsFields[formConstants.addressLine3];
        formData[formConstants.city] = ssoUserDetailsFields[formConstants.city];
        formData[formConstants.postcode] = ssoUserDetailsFields[formConstants.postcode];
        formData[formConstants.mobilePhone] = ssoUserDetailsFields[formConstants.mobilePhone];
        formData[formConstants.becomeOneClubMemberInfo] = ssoUserDetailsFields[formConstants.becomeOneClubMemberInfo];
        formData[formConstants.offersDetails] = ssoUserDetailsFields[formConstants.offersDetails];
        formData[formConstants.privacyPolicy] = ssoUserDetailsFields[formConstants.privacyPolicy];
        formData[formConstants.removeAccountInputText] = ssoUserDetailsFields[formConstants.removeAccountInputText];
        formData[formConstants.removeAccountInputWarning] = ssoUserDetailsFields[formConstants.removeAccountInputWarning];
        formData[formConstants.removeAccountModalWarning] = ssoUserDetailsFields[formConstants.removeAccountModalWarning];
        return formData;
    }

    function getUserDetailsFieldsWithDefaultValues(formData) {
        const { isOneClubMember } = userAccountData;
        const isWomensOpen = ssoDomain === domainConstants.womensOpen;

        formData[formConstants.emailAddress].defaultValue = userAccountData[formConstants.email];
        formData[formConstants.confirmEmailAddress].defaultValue = userAccountData[formConstants.email];
        formData[formConstants.title].defaultValue = userAccountData[formConstants.title];
        formData[formConstants.firstName].defaultValue = userAccountData[formConstants.firstName];
        formData[formConstants.lastName].defaultValue = userAccountData[formConstants.lastName];

        if (!_.isEmpty(userAccountData[formConstants.mobilePhone])) {
            formData[formConstants.mobilePhone].defaultValue = {};

            const userMobilePhone = _.cloneDeep(userAccountData[formConstants.mobilePhone]);

            const userCountryCodeMobilePhonePrefix = userAccountData[formConstants.countryCodeMobilePhonePrefix];

            const selectedCountry = getSelectedCountry(formData, userCountryCodeMobilePhonePrefix, userMobilePhone);

            formData[formConstants.mobilePhone].defaultValue.selectedCountry = selectedCountry;

            formData[formConstants.mobilePhone].defaultValue.phoneNumber = hasValue(selectedCountry) ?
                userMobilePhone.replace(selectedCountry.phonePrefix, '') :
                userMobilePhone;
        }

        if (userAccountData.dateOfBirth !== undefined) {
            formData[formConstants.dateOfBirth].defaultValue = createDateFromExisting(userAccountData.dateOfBirth);
        }

        let mainAddress = {};
        if (!isEmpty(userAccountData.addresses)) {
            const foundAddress = userAccountData.addresses.find((address) => address.main);
            mainAddress = isEmpty(foundAddress) ? {} : foundAddress;
        }

        formData[formConstants.addressLine1].defaultValue = mainAddress.addressLine1;
        formData[formConstants.addressLine2].defaultValue = mainAddress.addressLine2;
        formData[formConstants.addressLine3].defaultValue = mainAddress.addressLine3;
        formData[formConstants.postcode].defaultValue = mainAddress.postcode;
        formData[formConstants.city].defaultValue = mainAddress.city;
        formData[formConstants.country].defaultValue = mainAddress.country;
        formData[formConstants.county].defaultValue = mainAddress.county;
        formData[formConstants.state].defaultValue = mainAddress.state;

        const optIns = userAccountData[formConstants.optIns];
        formData[formConstants.offersDetails].defaultValue =
        {
            [formConstants.refuseOffers]: !optIns.optedTheOpenOffersByEmail,
            [formConstants.acceptOffers]: optIns.optedPartnerOffersByEmail
        };

        formData[formConstants.becomeOneClubMemberInfo].isHidden = isWomensOpen || isOneClubMember;

        formData[formConstants.privacyPolicy].defaultValue = optIns.agreedToPrivacyPolicy;

        return formData;
    }

    return buildUserDetailsFormData();
};

function getSelectedCountry(formData, userCountryCodeMobilePhonePrefix, userMobilePhone) {
    let selectedCountry = formData[formConstants.country].options
        .find((country) => !_.isEmpty(country.phonePrefix) &&
            country.code === userCountryCodeMobilePhonePrefix);

    if (selectedCountry) return selectedCountry;

    selectedCountry = formData[formConstants.country].options
        .find((country) => !_.isEmpty(country.phonePrefix) &&
            userMobilePhone.includes(country.phonePrefix));

    return selectedCountry;
}

export default UserDetailsFormData;
